package pl.finn.forms.swz

import io.kvision.form.text.TomTypeahead
import io.kvision.form.upload.UploadInput
import io.kvision.html.Button
import io.kvision.modal.Confirm
import io.kvision.redux.createReduxStore
import io.kvision.utils.getContent
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import pl.finn.forms.*


object Model : CoroutineScope by CoroutineScope(Dispatchers.Default + SupervisorJob())  {

    val formsService = FormsService()
    val swzService = SwzService()

    val formularzStore =
        createReduxStore(
            ::formularzReducer,
            Formularz(FormularzWidok.PUSTY)
        )

    fun nowy(token: String, app: App) {
        launchWithProgress {
            val formData = swzService.nowy(token)
            formularzStore.dispatch(FormularzAction.Nowy(formData))
            app.aktywujSwz()
            window.scrollTo(0.0, 0.0)
        }
    }


    fun sprawdz() {
        val state = Model.formularzStore.getState()
        launchWithProgress {
            val res = swzService.sprawdz(state.form!!, state.zalaczniki ?: emptyList(), state.token!!)
            println(res)
        }
    }

    fun zapisz(form: SwzForm, validateResult: Boolean?) {
        if(validateResult == null){
            launchWithProgress {
                val state = formularzStore.getState()
                val url = swzService.zapisz(form, state.zalaczniki ?: emptyList(), validateResult, state.token!!)
                window.location.href = url
            }
        } else {
            sprawdz()
        }
    }

    fun podglad(form: SwzForm, button: Button) {
        launchWithProgress {
            val state = formularzStore.getState()
            val xml = swzService.podglad(form, state.zalaczniki ?: emptyList(), state.token!!)
            PodgladWindow(state.token).pokazTresc(xml, button)
        }
    }

    fun edycja(token: String, app: App) {
        launchWithProgress {
            val formData = swzService.edycja(token)
            formularzStore.dispatch(FormularzAction.Edycja(formData))
            app.aktywujSwz()
            window.scrollTo(0.0, 0.0)
        }
    }

    fun anuluj() {
        launchWithProgress {
            val state = formularzStore.getState()
            val url = formsService.anuluj(state.token!!)
            window.location.href = url
        }
    }

    fun dodajZalacznik(zalacznik: UploadInput, opisZalacznika: String?, form: SwzForm) {
        launchWithProgress {
            zalacznik.value?.firstOrNull()?.let {
                val dataContent = zalacznik.getNativeFile(it)?.getContent()
                val parts = dataContent?.split(",")
                val mime = parts?.get(0)?.drop(5)?.dropLast(7)
                val content = parts?.getOrNull(1)
                Model.formularzStore.dispatch(
                    FormularzAction.DodajZalacznik(
                        Zalacznik(
                            it.name,
                            opisZalacznika,
                            mime,
                            content
                        ), form
                    )
                )
            }
        }
    }

    fun usunZalacznik(nazwa: String, form: SwzForm) {
        Confirm.show(
            "Potwierdzenie",
            "Czy na pewno usunąć wybrany załącznik?",
            yesTitle = "Tak",
            noTitle = "Nie"
        ) {
            formularzStore.dispatch(FormularzAction.UsunZalacznik(nazwa, form))
        }
    }
    fun onEditPostalCodeRefresh(postalCode: String?, officeSelect: TomTypeahead, localitySelect: TomTypeahead, streetSelect: TomTypeahead) {

        launchWithProgress {
            val officeList: ArrayList<String> = arrayListOf()
            val localicityList: ArrayList<String> = arrayListOf()
            val streetList: ArrayList<String> = arrayListOf()
            val result = pl.finn.forms.podpp.Model.terytApiService.addresses(postalCode)
            if(!result.addresses.isEmpty()) {
                officeSelect.removeAll()
                localitySelect.removeAll()
                streetSelect.removeAll()
                for (address in result.addresses) {
                    addToSelect(officeList, address.office)
                    addToSelect(localicityList, address.locality)
                    addToSelect(streetList, address.street)
                }
                officeSelect.options = officeList
                localitySelect.options = localicityList
                streetSelect.options = streetList
            }
        }
    }
    private fun addToSelect(singleList: ArrayList<String>, value: String?) {
        if(value != null && !value.isNullOrEmpty() && !value.isBlank() && !singleList.contains(value)){
            singleList.add(value)
        }
    }
}